import { CircularProgress, SWAPLogo } from '@yosgo/swap-ui'
import React from 'react'

interface MobileCustomerFileLayoutProps {
  download: () => void
  downloadLoading: boolean
  print: () => void
}

const MobileCustomerFileLayout = ({
  download,
  downloadLoading,
  print,
}: MobileCustomerFileLayoutProps) => {
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 1090,
        top: 0,
        width: '100%',
        height: 64,
        backgroundColor: '#ffffff',
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: 'inset 0px -1px 0px #DADADA',
      }}
    >
      <div onClick={() => (window.location.href = `${window.location.origin}`)}>
        <SWAPLogo />
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 16,
          }}
          onClick={download}
        >
          {downloadLoading ? <CircularProgress /> : icon_download}
        </div>
        <div
          style={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={print}
        >
          {icon_print}
        </div>
      </div>
    </div>
  )
}

const icon_download = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16675 16.6667H15.8334V15H4.16675V16.6667ZM15.8334 7.5H12.5001V2.5H7.50008V7.5H4.16675L10.0001 13.3333L15.8334 7.5Z"
      fill="black"
    />
  </svg>
)

const icon_print = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8334 6.66667H4.16675C2.78341 6.66667 1.66675 7.78333 1.66675 9.16667V14.1667H5.00008V17.5H15.0001V14.1667H18.3334V9.16667C18.3334 7.78333 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66675V11.6667H13.3334V15.8333ZM15.8334 10C15.3751 10 15.0001 9.625 15.0001 9.16667C15.0001 8.70833 15.3751 8.33333 15.8334 8.33333C16.2917 8.33333 16.6667 8.70833 16.6667 9.16667C16.6667 9.625 16.2917 10 15.8334 10ZM15.0001 2.5H5.00008V5.83333H15.0001V2.5Z"
      fill="black"
    />
  </svg>
)

export default MobileCustomerFileLayout
